import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react/dist/iconify.js";
import secureLocalStorage from "react-secure-storage";
import duration from "dayjs/plugin/duration";
import { toast } from "react-toastify";
dayjs.extend(duration);

const PricingSubscription = () => {
  const { t } = useTranslation();
  const [subscription, setSubscription] = useState({});
  const [loading, setLoading] = useState(true);

  console.log("Subscription data:", subscription);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const storedData = secureLocalStorage.getItem("loginCredentials");

        if (!storedData || !storedData.user || !storedData.user.id) {
          console.error("User ID not found in secureLocalStorage");
          return;
        }

        const userId = storedData.user.id;

        const response = await fetch(
          `${process.env.REACT_APP_NODE_BASE_URL}/stripe/get-subscription/${userId}`
        );

        const data = await response.json();

        if (data.current_period_end) {
          console.log("Subscription expires at:", data.current_period_end);

          const now = dayjs();
          const expiry = dayjs.unix(data.current_period_end);
          const diff = expiry.diff(now, "seconds");

          if (diff > 0) {
            const duration = dayjs.duration(diff, "seconds");
            const timeLeft = `${Math.floor(
              duration.asDays()
            )}d ${duration.hours()}h ${duration.minutes()}m`;

            data.timeLeft = timeLeft;
          } else {
            data.timeLeft = "Expired";
          }
        } else {
          console.warn("No current_period_end found in subscription data");
        }

        setSubscription(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subscription:", error);
        setLoading(false);
      }
    };

    fetchSubscription();
  }, []);

  const handleCheckout = async (planType) => {
    try {
      const storedData = secureLocalStorage.getItem("loginCredentials");
      if (!storedData || !storedData.user || !storedData.user.id) {
        console.error("User ID not found in secureLocalStorage");
        return;
      }

      const userId = storedData.user.id;

      const response = await fetch(
        `${process.env.REACT_APP_NODE_BASE_URL}/stripe/create-checkout-session`,
        {
          method: "POST",
          body: JSON.stringify({ userId, planType }),
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (data.error) {
        toast.error(data.error || "something went wrong");
      }
      if (data.url) window.location.href = data.url;
      else console.error("Stripe response does not contain a URL:", data);
    } catch (error) {
      console.error("Stripe checkout error:", error);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      const storedData = secureLocalStorage.getItem("loginCredentials");
      if (!storedData || !storedData.user || !storedData.user.id) {
        console.error("User ID not found in secureLocalStorage");
        return;
      }

      const userId = storedData.user.id;
      console.log("Initiating cancel request for user ID:", userId);

      const response = await fetch(
        `${process.env.REACT_APP_NODE_BASE_URL}/stripe/cancel-subscription`, // Fix: Removed userId from URL
        {
          method: "POST", // Fix: Changed from DELETE to POST
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId }), // Fix: Send userId in body
        }
      );

      console.log("Cancel Subscription API response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Subscription canceled successfully:", data);

        // Reset subscription state after cancellation
        setSubscription({});
      } else {
        console.error("Failed to cancel subscription:", await response.text());
      }
    } catch (error) {
      console.error("Error canceling subscription:", error);
    }
  };

  const pricingData = [
    {
      planName: "Basic",
      plan: t("home.pricing.basicPlan.title"),
      price: t("home.pricing.basicPlan.price"),
      features: [
        t("home.pricing.planFeatures.one"),
        t("home.pricing.planFeatures.two"),
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
      ],
      cardClass: "basic",
      contentClass: "text-white",
      headingClass: "text-white",
      priceClass: "text-white",
      buttonClass: "bg-[#ADD8E6]",
      marginClass: "mt-[15px]",
      // buttonLabel: "Activated",
      // buttonBgImg: "../../../../assets/images/dashboard/button-bg.png",
      // buttonTextClass: "text-black",
      buttonLabel: "Get Started",
      buttonBgImg: "../../../../assets/images/dashboard/btn-bg-2.png",
      buttonTextClass: "text-white",
      imgTop: "../../../../assets/images/dashboard/subs-top-blue.png",
      imgBottom: "../../../../assets/images/dashboard/subs-botton-blue.png",
    },
    {
      planName: "Premium",
      plan: t("home.pricing.premiumPlan.title"),
      price: t("home.pricing.premiumPlan.price"),
      features: [
        t("home.pricing.planFeatures.one"),
        t("home.pricing.planFeatures.two"),
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
      ],
      cardClass: "premium",
      contentClass: "text-blue",
      headingClass: "text-blue",
      priceClass: "text-secondary",
      marginClass: "mt-[15px]",
      buttonLabel: "Get Started",
      buttonClass: "bg-[#007bff]",
      buttonBgImg: "../../../../assets/images/dashboard/btn-bg-2.png",
      buttonTextClass: "text-white",
      imgTop: "../../../../assets/images/dashboard/subs-top-white.png",
      imgBottom: "../../../../assets/images/dashboard/subs-bottomwhite.png",
    },
    {
      planName: "Exclusive",
      plan: "Exclusive",
      price: "",
      features: [
        t("home.pricing.planFeatures.three"),
        t("home.pricing.planFeatures.four"),
        t("home.pricing.planFeatures.five"),
        t("home.pricing.planFeatures.six"),
      ],
      cardClass: "exclusive",
      contentClass: "text-blue",
      priceClass: "text-blue",
      marginClass: "mt-[40px]",
      headingClass: "text-blue",
      buttonLabel: "Coming Soon",
      buttonClass: "bg-[#6c757d]",
      buttonBgImg: "../../../../assets/images/dashboard/btn-bg-2.png",
      buttonTextClass: "text-white",
      imgTop: "../../../../assets/images/dashboard/subs-top-white.png",
      imgBottom: "../../../../assets/images/dashboard/subs-bottomwhite.png",
    },
  ];

  return (
    <div className="pricing-container bg-[rgb(207, 207, 207)] py-10 px-10 rounded-xl shadow-lg flex flex-col items-center">
      <h2 className="text-center text-blue text-3xl font-bold mb-6">
        {t("pricing.title")}
      </h2>
      <div className="grid grid-col-1  md:grid-cols-3 gap-6 w-full max-w-3xl  sm-s:grid-cols-1 max-sm:justify-items-center">
        {pricingData.map((plan, index) => (
          <div
            className={`pricing-card-${plan.cardClass} w-full max-sm:max-w-[200px]`}
            key={index}
          >
            <div className="card-top relative drop-shadow-md">
              <img
                src={
                  subscription.plan === plan.planName
                    ? "../../../../assets/images/dashboard/subs-top-blue.png"
                    : "../../../../assets/images/dashboard/subs-top-white.png"
                }
                alt={plan.plan}
                className="w-full"
              />
              <div className="w-full absolute top-[10px]">
                <h5
                  className={`${
                    subscription.plan === plan.planName
                      ? "text-white"
                      : "text-blue"
                  } font-bold font-manrope text-center`}
                >
                  {plan.plan}
                </h5>
              </div>
            </div>
            <div className="card-bottom relative mt-[-30px] drop-shadow-md">
              <img
                src={
                  subscription.plan === plan.planName
                    ? "../../../../assets/images/dashboard/subs-botton-blue.png"
                    : "../../../../assets/images/dashboard/subs-bottomwhite.png"
                }
                alt={plan.plan}
                className="w-full"
              />
              <div className="content absolute top-[10px] w-full p-[14px]">
                {plan.price && (
                  <p
                    className={`text-center text-lg ${
                      subscription.plan === plan.planName
                        ? "text-white"
                        : "text-blue"
                    } font-bold`}
                  >
                    {plan.price}
                  </p>
                )}
                <ul className={`space-y-2 ${plan.marginClass} `}>
                  {plan.features.map((feature, index) => (
                    <li
                      className={`flex   items-center gap-2 ${
                        subscription.plan === plan.planName
                          ? "text-white"
                          : "text-blue"
                      }`}
                      key={index}
                    >
                      <Icon
                        icon="lets-icons:check-fill"
                        width={22}
                        height={22}
                      />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div
              className="card-button relative mt-[15px] cursor-pointer"
              onClick={() => {
                handleCheckout(plan.plan);
              }}
            >
              <img
                src={plan.buttonBgImg}
                alt="button background"
                className="w-full"
              />
              <div className="w-full absolute top-[9px]">
                <p
                  className={`medium font-semibold font-manrope text-center ${plan.buttonTextClass}`} // Using dynamic button text class
                >
                  {subscription.plan === plan.planName
                    ? "Subscribed"
                    : plan.buttonLabel}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center w-full mt-10">
        <div className="w-full max-w-2xl p-6 bg-[rgb(248,248,248)] rounded-[20px] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] border-[1.299px] border-[rgba(255,255,255,0.28)]">
          <h1 className="text-blue font-bold text-xl mb-4 text-left">
            Subscription
          </h1>

          {loading ? (
            <p className="text-center">Loading...</p>
          ) : subscription?.status ? (
            <>
              <div className="grid grid-cols-3 gap-4 items-center border-b pb-4 mb-4">
                <p className="text-blue font-semibold">Status:</p>
                <p
                  className={`text-lg font-semibold col-span-2 ${
                    subscription.status === "active"
                      ? "text-green-600"
                      : "text-red-500"
                  }`}
                >
                  {subscription?.status
                    ? subscription.status.charAt(0).toUpperCase() +
                      subscription.status.slice(1)
                    : "N/A"}
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4 items-center border-b pb-4 mb-4">
                <p className="text-blue font-semibold">Plan:</p>
                <p className="text-lg font-semibold text-blue-600 col-span-2">
                  {subscription.plan || "N/A"}
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4 items-center border-b pb-4 mb-4">
                <p className="text-blue font-semibold">Price:</p>
                <p className="text-lg font-semibold text-blue-600 col-span-2">
                  {subscription.amount && subscription.currency
                    ? `$${
                        subscription.amount
                      } ${subscription.currency.toUpperCase()}`
                    : "N/A"}
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4 items-center pb-4 mb-4">
                <p className="text-blue font-semibold">Time Left:</p>
                {/* <p className="text-lg font-semibold text-red-500 col-span-2">
                        {subscription.timeLeft ? `${subscription.timeLeft}` : "N/A"}
                      </p> */}
                <p className="text-lg font-semibold text-red-500 col-span-2">
                  {subscription.timeLeft ? `${subscription.timeLeft}` : "N/A"}
                </p>
              </div>

              <div className="flex justify-end mt-6">
                <Button
                  className="bg-red text-white px-4 py-2 rounded-lg"
                  onClick={handleCancelSubscription}
                >
                  Cancel
                </Button>
              </div>
            </>
          ) : (
            <p className="text-center text-red-500">No active subscription</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingSubscription;
